import store from 'state'
import BigNumber from 'bignumber.js'
import { DEFAULT_LOCAL_CURRENCY } from 'config/constants'
import localCurrencies from 'config/constants/localCurrencies'
import { getLocalCurrencyExRate } from './getLocalCurrencyExRate'

/**
 * Function to return a fiat value of an amount
 * @param value USD amount
 * @return target currency amount
 */
const getFiatValue = (value: number | BigNumber, localCurrency?: string): BigNumber => {
  const state = store.getState()
  let currency: string
  if (localCurrency && Object.keys(localCurrencies).includes(localCurrency.toUpperCase())) {
    currency = localCurrency.toUpperCase()
  } else {
    currency = state.user.localCurrency ?? DEFAULT_LOCAL_CURRENCY
  }
  return (new BigNumber(value)).times(getLocalCurrencyExRate(currency))
}

export default getFiatValue
